module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('circle', {
    class: {
      'white-stone': _vm.isWhite, 'black-stone': _vm.isBlack
    },
    attrs: {
      "r": _vm.size,
      "cx": _vm.x,
      "cy": _vm.y
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3884d6c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/game/Stone.vue
// module id = 418
// module chunks = 1